import React from 'react'
import {usePreBookStore} from '../store/hooks/useStore'

const useDeliveryPreBooking = () => {
  const [loadingPreBook, setLoadingPreBook] = React.useState<boolean>(false)
  const {
    getPreBookDeliverySlots: _getPreBookDeliverySlots,
    setPreBookPostalCode
  } = usePreBookStore()

  const getPreBookDeliverySlots = async () => {
    setLoadingPreBook(true)
    try {
      await _getPreBookDeliverySlots()
      setLoadingPreBook(false)
    } catch (error) {
      console.error('Error fetching pre-book delivery slots', error)
      setLoadingPreBook(false)
    }
  }

  const setPreBookPostCode = async (postcode: string | undefined) => {
    setLoadingPreBook(true)
    try {
      await setPreBookPostalCode(postcode)
      setLoadingPreBook(false)
    } catch (error) {
      console.error('Error checking pre-book postal code', error)
      setLoadingPreBook(false)
    }
  }

  return {
    loadingPreBook,
    setLoadingPreBook,
    getPreBookDeliverySlots,
    setPreBookPostCode
  }
}

export default useDeliveryPreBooking